import { useMapLayoutPositions } from '@/shared/states/mapLayout'
import { useMyTicketStore } from '@/shared/states/myTicket'
import { useGlobalCachedPins } from '@/shared/states/parkinglot'
import { usePurchaseStep, useIsPurchase } from '@/shared/states/purchase'
import { useRefundStore } from '@/shared/states/refund'
import { useStorageStore } from '@/shared/states/storage'

const states = {
  useMapLayoutPositions,
  usePurchaseStep,
  useIsPurchase,
  useGlobalCachedPins,
  useStorageStore,
  useRefundStore,
  useMyTicketStore
}

export default states
